<template>
  <div class="task"></div>
</template>

<script>
export default {
  name: 'definition-task-refresh',
  props: [
    'refresh'
  ],
  methods: {
    callRefresh () {
      this.$emit('refreshDefinitionContent')
    }
  },
  watch: {
    refresh (refresh) {
      this.callRefresh()
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// node_modules/vue-definition/src/components/item/task/taskRefresh.vue